import type {
  ZipCodeAddressLookupParams,
  ZipCodeAddressLookupResponse,
} from '../../types/vida/cep/cepType';
import { VIDA_CEP_ROUTES } from '../requestsService';

function buildQueryString(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.append(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export class CepService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Looks up street address data by zip code (obter-dados-logradouro-consulta-cep).
   * @param params.numPrefixoCEP - Zip code prefix (5 digits)
   * @param params.numSufixoCEP - Zip code suffix (3 digits)
   * @param params.descrLogradouro - Optional street name filter
   */
  async getStreetAddressByZipCode(
    params: ZipCodeAddressLookupParams,
  ): Promise<ZipCodeAddressLookupResponse> {
    const url =
      VIDA_CEP_ROUTES.GET_OBTER_DADOS_LOGRADOURO_CONSULTA_CEP +
      buildQueryString({
        numPrefixoCEP: params.numPrefixoCEP,
        numSufixoCEP: params.numSufixoCEP,
        descrLogradouro: params.descrLogradouro,
      });

    return this.fetch<ZipCodeAddressLookupResponse>(url, { method: 'GET' });
  }
}
